// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__zO85g","label":"default_label__Iz4dh","field":"default_field__n4yI5"};